import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'
import {DownloadIcon} from "../../../../../icons";
import React from "react";
import {formatTime, formatUIDate} from "../../../../../utils/helpers";

export const toolbarActions = ({
                                 totalCount,
                                 exportFileExcel,
                                 isExcelExportLoading
                               }) => {
  let actions = []

  if (totalCount>0 && totalCount<=1000) {
    actions = [
      ...actions,
      {
        label: isExcelExportLoading ? 'Export in curs...' : 'Export Excel',
        icon: <DownloadIcon />,
        onClick: isExcelExportLoading ? () => {} : exportFileExcel
      }
    ]
  }

  return actions
}

export const statusColorMapping = {
  Cuvă: 'blue',
  Sac: 'green',
}

export const columns = [
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'ID Returo',
    field: 'idReturo',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Numar sigiliu',
    field: 'sealCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Datǎ inregistrare',
    field: 'created',
    align: 'left',
    type: 'string',
    width: '100px',
    render: row => `${formatUIDate(row.created)} ${formatTime(row.created)}`,
  },
  {
    title: 'Operator',
    field: 'createdBy',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Material',
    field: 'materialType',
    align: 'left',
    type: 'string',
    render: row => (
      <div style={{ color: statusColorMapping[row.materialTypeValue] || 'black' }}>{row.materialTypeValue}</div>
    ),
    width: '100px'
  }
]

export const materialTypes = [
  {
    label: 'Cuvă',
    value: 'VAT',
  },
  {
    label: 'Sac',
    value: 'SACK',
  },
]

export const drawerFilters = (shopOptions) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selectează magazin'
  },
  {
    name: 'materialType',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează tip material"
        disableClearable
        options={materialTypes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează tip material'
  },
  {
    name: 'createdBy',
    value: '',
    filter: <Input variant="outlined" label="Nume operator" type="text" />,
    type: 'text',
    label: 'Nume operator'
  },
  {
    name: 'created',
    value: '',
    filter: (
      <DatePicker
        label="Selectează data de inceput"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de inceput',
    disableFuture: true
  },
  {
    name: 'createdTo',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data de sfarsit"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de sfarsit',
    disableFuture: true
  }
]
